import { orderStore, setOrderStore, TabType } from '@store/orders';

export const MobileLoadSelect = () => {
  const getActiveStyles = (index: number) => {
    return orderStore.activeTab.index === index ? 'bg-[#ffe8b7]' : 'bg-white';
  };
  return (
    <div class="mb-2">
      {orderStore.order.loads.map((load, index) => (
        <div
          class={`p-2 rounded-md border border-gray-200 font-medium text-sm text-center ${getActiveStyles(
            index,
          )}`}
        >
          <div
            onClick={() => {
              setOrderStore('activeTab', {
                type: TabType.load,
                index: orderStore.order.loads.indexOf(load),
              });
            }}
          >
            {load.carrierName ?? 'Carrier'}
          </div>
        </div>
      ))}
      {orderStore.order.vendors?.map((vendor, index) => (
        <div
          class={`p-2 rounded-md border border-gray-200 font-medium text-sm text-center ${getActiveStyles(
            index,
          )}`}
        >
          <div
            onClick={() => {
              setOrderStore('activeTab', {
                type: TabType.vendor,
                index: orderStore.order.vendors?.indexOf(vendor) ?? 0,
              });
            }}
          >
            {vendor.name}
          </div>
        </div>
      ))}
    </div>
  );
};
